import { useContext, useEffect, useRef, useState } from 'react';

import type { IAuthUser } from '../AuthClient';
import { MultiSessionsContext } from '../MultiSessionsContext';
import { useAuth } from './useAuth';

export const useAuthUser = (): IAuthUser | undefined => {
  const auth = useAuth();
  const [user, setUser] = useState<IAuthUser>();
  const multiSessionsContext = useContext(MultiSessionsContext);

  const isInitRef = useRef(false);
  useEffect(() => {
    if (isInitRef.current) {
      return;
    }

    if (!multiSessionsContext.currentId) {
      return;
    }

    void auth
      .getClient()
      .getUser(multiSessionsContext.currentId)
      .then((user) => setUser(user));
  }, [auth, multiSessionsContext]);

  return user;
};
